
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claude-api-ui",
      function () {
        return require("private-next-pages/claude-api-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claude-api-ui"])
      });
    }
  